'use client'
import type { FC } from 'react'
import styles from './ChatBubble.module.scss'
import { useCourierChat } from '@/help-center/useCourierChat'
import { useHelpCenter } from '@/help-center/useHelpCenter'
import { useLocalisation } from '@/tools/i18n/client'
import {
  Badge,
  BadgeSize,
  BadgeStyle,
  ChatBubblesIcon,
  IconButton,
  IconButtonSize,
  IconButtonVariants,
} from '@/tools/ui'

export const ChatBubble: FC = () => {
  const { t } = useLocalisation()

  const { chat: agentChat, openHelpCenter } = useHelpCenter()
  const { chats: courierChats, openCourierChat } = useCourierChat()

  const hasActiveCourierChat = courierChats.some((chat) => chat.active)

  const hasUnreadMessage =
    agentChat.unreadMessageCount > 0 || courierChats.some((chat) => chat.unreadMessageCount > 0)

  const handleOpenChat = () => {
    if (hasActiveCourierChat) {
      const activeCourierChatOrderId = courierChats.find((chat) => chat.active)?.orderId
      if (activeCourierChatOrderId) {
        openCourierChat(Number(activeCourierChatOrderId))
      }
    } else {
      openHelpCenter()
    }
  }

  return (
    <div className={styles.chatBubble} data-testid="chat-bubble">
      {hasUnreadMessage && (
        <Badge
          className={styles.notificationBadge}
          size={BadgeSize.small}
          style={BadgeStyle.critical}
        />
      )}
      <IconButton
        aria-label={t('support_center_title')}
        icon={ChatBubblesIcon}
        size={IconButtonSize.large}
        variant={IconButtonVariants.primary}
        onClick={handleOpenChat}
      />
    </div>
  )
}
